import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=b1c9e7ea&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=b1c9e7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c9e7ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1c9e7ea')) {
      api.createRecord('b1c9e7ea', component.options)
    } else {
      api.reload('b1c9e7ea', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=b1c9e7ea&scoped=true&", function () {
      api.rerender('b1c9e7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-221B2NMxSpiin/JS/comp/PopupBox.vue"
export default component.exports